import React from "react"

import Layout from "../components/Layout"
import Projects from "../components/Projects"

function projects() {
  return (
    <Layout>
      <Projects />
    </Layout>
  )
}

export default projects
